// @ts-nocheck
import {Page} from '@/interfaces/server-data';

import {
  ISaleSaveDto,
  ISaleQueryDto,
  ISaleResponseDto,
  ISaleFilterOptions,
  ISale
} from "@/pages/Sales/data";

import {Component, Mixins} from 'vue-property-decorator';
import {AxiosPromise} from 'axios';

@Component
export default class SalesApi extends Mixins() {
  private basePath = '/api/sales';

  fetchSales(query: ISaleQueryDto): AxiosPromise<Page<ISaleResponseDto[]>> {
    return this.$http.get(`${this.basePath}`, {params: query});
  }

  fetchSalesWithFilters(filtersObject: any, usualParams: any) {
    function constructQuery(filtersObject: any, usualParams: any) {
      const queryParams = [];

      for (const key in filtersObject) {
        const value = filtersObject[key];
        const valueIsArray = Array.isArray(value);

        if (value !== null && (!valueIsArray || valueIsArray && value.length)) {
          queryParams.push(`${encodeURIComponent('filterField')}=${encodeURIComponent(key)}`);

          if (valueIsArray) {
            queryParams.push(`${encodeURIComponent('filterValue')}=${encodeURIComponent(value.join(';'))}`);
          } else {
            queryParams.push(`${encodeURIComponent('filterValue')}=${encodeURIComponent(value)}`);
          }
        }
      }

      for (const paramKey in usualParams) {
        queryParams.push(`${encodeURIComponent(paramKey)}=${encodeURIComponent(usualParams[paramKey])}`);
      }

      return queryParams.join('&');
    }

    const queryString = constructQuery(filtersObject, usualParams);

    return this.$http.get(`${this.basePath}?${queryString}`, {});
  }


  fetchFilterOptions(tradingId: number): AxiosPromise<Page<ISaleFilterOptions[]>> {
    return this.$http.get(`${this.basePath}/options`, {params: { tradingId }});
  }

  saveSale(saleParams: ISaleSaveDto): AxiosPromise<ISale> {
    if (saleParams.id != null && saleParams.id > 0) {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

      return this.$http.patch(`${this.basePath}/${saleParams.id}`, saleParams, { params: { userId } });
    } else {
      return this.$http.post(this.basePath, saleParams);
    }
  }

  deleteSale(id: number): AxiosPromise<any> {
    const auth = localStorage.getItem('AUTH');
    if (!auth) return Promise.reject();

    const { user_id: userId } = JSON.parse(auth);

    return this.$http.delete(`${this.basePath}/${id}`, { params: { userId } })
  }

  createScheduleFromSale(saleId: number): AxiosPromise<string> {
    return this.$http.post(`${this.basePath}/${saleId}/schedules`);
  }
}
